export default{
    
    lista:{
        method:'get',
        url:'folhar/evento1270/lista'
    },
    cadastra:{
        method:'post',
        url:'folhar/evento1270/cadastro'
    },
    update1270:{
        method:'put',
        url:'folhar/evento1270/update'
    },
    delete1270:{
        method:'delete',
        url:'folhar/evento1270/deletar{/id}'
    },
    delete:{
        method:'delete',
        url:'basecalculo/deletar{/id}'
    },
}